import React from 'react';
import CommentForm from './CommentForm';
import LoadMore from './LoadMore';
import moment from 'moment';

class Comment extends React.Component {
  constructor(props) {
    super(...arguments);
    this.state = {
      addComment: false
    };
    this.addComment = this.addComment.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.loadMore = this.loadMore.bind(this);
    let level = props.level ? props.level : 1;
    if (typeof props.comment.get('id') !== 'undefined' && level < 2) {
      //console.log('FETCHING!', props.comment);
      //props.comment.get('comments').fetch();
    }
    this.approveComment = this.approveComment.bind(this);
  }

  componentDidMount() {
    this.props.comment.get('comments').on(
      'sync',
      () => {
        this.setState({
          loading: false
        });
      },
      this
    );
  }

  componentWillUnmount() {
    this.props.comment.get('comments').off(null, null, this);
  }

  addComment() {
    this.setState({
      addComment: true
    });
  }

  onAdd() {
    this.setState({
      addComment: false
    });
  }

  onAddNeedingApproval = () => {
    this.setState({
      addComment: false,
      message: 'Thank you! Your comment was added, but will not appear publicly until approved by the site administrator.'
    });
  };

  deleteComment = () => {
    FW.getParent()
      .swal.fire({
        icon: 'question',
        title: 'Delete?',
        text: 'Are you sure you want to delete this comment?',
        showCancelButton: true
      })
      .then(() => {
        this.props.comment.destroy({
          success: () => {
            if (this.props.onDelete) this.props.onDelete();
          }
        });
      })
  };

  approveComment() {
    FW.getParent()
      .swal.fire({
        icon: 'question',
        title: 'Approve?',
        text: 'Are you sure you would like to approve this comment?',
        showCancelButton: true
      })
      .then(() => {
        this.props.comment
          .save({
            approved_at: moment().format('YYYY-MM-DD HH:mm:ss')
          })
          .then(() => {
            this.forceUpdate();
          });
      });
  }

  loadMore() {
    this.setState({
      loading: true
    });
    this.props.comment.get('comments').loadMore();
  }

  onDelete = () => {
    this.forceUpdate();
  };

  render() {
    let comment = this.props.comment;
    let level = this.props.level ? this.props.level : 1;
    let comments = comment.get('comments').map(c => {
      return c.get('created_at') ? (
        <Comment
          key={`comment-${c.get('id')}`}
          comment={c}
          parentComment={comment}
          parent={this.props.parent}
          level={level + 1}
          onDelete={this.onDelete}
        />
      ) : null;
    });

    let showLoadMore =
      (comment.get('comments').length > 0 &&
        comments.length > 0 &&
        comments[comments.length - 1] === null) ||
      comment.get('comments').pagination.total > comment.get('comments').length;
    let className = 'load-more-comments col-md-5 col-md-offset-' + level;
    let indentClass = 'col-sm-1 col-xs-offset-' + (level - 1);
    let loadMore = showLoadMore ? (
      <LoadMore
        className={className}
        onClick={this.loadMore}
        loading={this.state.loading}
      />
    ) : null;
    let formClass = 'col-md-6 col-xs-offset-' + level;
    let user = FW.store.get('user');
    let commentWrapperClass =
      'comments-wrapper' +
      (comment.needsApproval &&
      user &&
      user.may('manage_blog_comments', this.props.parent)
        ? ' needs-approval'
        : '');

    const shouldHide = comment.needsApproval && (!user || !user.may('manage_blog_comments', this.props.parent));
    return shouldHide ? null : (
      <div className={commentWrapperClass}>
        <div className="row">
          <div className={indentClass}>
            <div className="thumbnail">
              <img
                className="img-responsive user-photo"
                src="https://ssl.gstatic.com/accounts/ui/avatar_2x.png"
              />
            </div>
          </div>
          <div className="col-sm-5">
            <div className="panel panel-default">
              <div className="panel-heading comment-author">
                <strong>
                  {(comment.get('user')
                    ? comment.get('user').get('name')
                    : comment.get('name')) || 'Anonymous'}
                </strong>
                {user && user.may('manage_blog_comments') ? <span><br />{comment.get('email')}</span> : null}
                <span className="pull-right comment-details">
                  <span className="comment-time">{comment.createdTime}</span>
                  {/*<i className="fa fa-heart"></i>*/}
                  {this.props.parent.commentsAllowed ? (
                    <i className="fa fa-reply" onClick={this.addComment}></i>
                  ) : null}
                  {comment.needsApproval &&
                  user &&
                  user.may('manage_blog_comments', this.props.parent) ? (
                    <i
                      className="fa fa-check"
                      title="Approve This Comment"
                      onClick={this.approveComment}
                    ></i>
                  ) : null}
                  {user && user.may('delete_blog_comments', this.props.parent) ? <i
                    className="fa fa-trash"
                    title="Delete This Comment"
                    onClick={this.deleteComment}
                  ></i> : null}
                </span>
              </div>
              <div className="panel-body comment-content">
                {comment.get('content')
                  ? comment
                      .get('content')
                      .split('\n')
                      .map((item, key) => {
                        return (
                          <span key={key}>
                            {item}
                            <br />
                          </span>
                        );
                      })
                  : null}
              </div>
            </div>
          </div>
          {this.state.addComment ? (
            <div className="row" style={{marginBottom: 20}}>
              <div className="col-md-12">
                <div className={formClass}>
                  <CommentForm
                    parent={this.props.parent}
                    parentComment={comment}
                    onAdd={this.onAdd}
                    onAddNeedingApproval={this.onAddNeedingApproval}
                  />
                </div>
              </div>
            </div>
          ) : null}
          <div className="col-md-12">
            {this.state.message ? <p style={{textAlign: 'center', padding: 15}} className="lead">{this.state.message}</p> : null}
            {comments}
            {loadMore}
          </div>
        </div>
      </div>
    );
  }
}

export default Comment;
